/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetSupportTicketQueryResponse, GetSupportTicketPathParams, GetSupportTicket400, GetSupportTicket401, GetSupportTicket403, GetSupportTicket404, GetSupportTicket409, GetSupportTicket500 } from "../../types/supportController/GetSupportTicket.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getSupportTicket } from "../../client/supportController/getSupportTicket.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getSupportTicketQueryKey = (id: GetSupportTicketPathParams["id"] | undefined) => [{ url: '/api/support/tickets/:id', params: {id:id} }] as const

export type GetSupportTicketQueryKey = ReturnType<typeof getSupportTicketQueryKey>

export function getSupportTicketQueryOptions(id: GetSupportTicketPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getSupportTicketQueryKey(id)
        return queryOptions<GetSupportTicketQueryResponse, ResponseErrorConfig<GetSupportTicket400 | GetSupportTicket401 | GetSupportTicket403 | GetSupportTicket404 | GetSupportTicket409 | GetSupportTicket500>, GetSupportTicketQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getSupportTicket(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get support ticket by ID
 * {@link /api/support/tickets/:id}
 */
export function useGetSupportTicket<TData = GetSupportTicketQueryResponse, TQueryData = GetSupportTicketQueryResponse, TQueryKey extends QueryKey = GetSupportTicketQueryKey>(id: GetSupportTicketPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetSupportTicketQueryResponse, ResponseErrorConfig<GetSupportTicket400 | GetSupportTicket401 | GetSupportTicket403 | GetSupportTicket404 | GetSupportTicket409 | GetSupportTicket500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getSupportTicketQueryKey(id)
         

         const query = useQuery({
          ...getSupportTicketQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetSupportTicket400 | GetSupportTicket401 | GetSupportTicket403 | GetSupportTicket404 | GetSupportTicket409 | GetSupportTicket500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}